function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { Grid } from 'semantic-ui-react';
import InlineSvg from './InlineSvg';


import LoadSVG from './LoadSVG';

var NineDotMenu = function (_React$Component) {
  _inherits(NineDotMenu, _React$Component);

  function NineDotMenu(props) {
    _classCallCheck(this, NineDotMenu);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onNineDotClick = function () {
      _this.setState({
        nineDotMouseOut: false
      });
      if (_this.state.nineDotMouseOut === false) {
        _this.setState({
          nineDotMenuOpen: true
        });
      }
    };

    _this.onNineDotMouseOver = function () {
      _this.setState({
        nineDotMouseOut: false
      });
    };

    _this.onNineDotMouseLeave = function () {
      _this.setState({
        nineDotMouseOut: true
      });
      setTimeout(function () {
        if (this.state.nineDotMouseOut === true) {
          this.setState({
            nineDotMenuOpen: false
          });
        }
      }.bind(_this), 300);
    };

    _this.getCookie = function (name) {
      var value = '; ' + document.cookie;
      var parts = value.split('; ' + name + '=');
      if (parts.length === 2) return parts.pop().split(';').shift();
    };

    _this.switchToClick = function (email, switchFromEmail, switchFromToken) {
      var switchTo = _this.props.switchTo;

      switchTo(email, switchFromEmail, switchFromToken).then(function (success) {
        return window.location.replace('/');
      });
    };

    _this.state = {
      nineDotMenuOpen: false,
      nineDotMouseOut: true
    };
    return _this;
  }

  NineDotMenu.prototype.render = function render() {
    var _this2 = this;

    var _props$products = this.props.products,
        products = _props$products === undefined ? [] : _props$products;


    var switchFromToken = this.getCookie('switchFromToken');
    var switchFromEmail = this.getCookie('switchFromEmail');

    return React.createElement(
      'div',
      { className: 'nine-dot' },
      React.createElement(
        'a',
        {
          className: 'nine-dot__icon',
          onClick: this.onNineDotClick,
          onFocus: this.onNineDotClick,
          onMouseOut: this.onNineDotMouseLeave,
          onMouseOver: this.onNineDotMouseOver,
          onBlur: this.onNineDotMouseLeave
        },
        React.createElement(InlineSvg, { name: 'nineDot' }),
        React.createElement(InlineSvg, {
          name: 'dropDownArrow',
          className: 'dropdown-arrow ' + (this.state.nineDotMenuOpen ? 'dropdown-arrow--open' : '')
        })
      ),
      React.createElement(
        'div',
        {
          className: 'nine-dot__menu ' + (this.state.nineDotMenuOpen ? 'nine-dot__menu--open' : ''),
          onFocus: this.onNineDotClick,
          onMouseOut: this.onNineDotMouseLeave,
          onMouseOver: this.onNineDotMouseOver,
          onBlur: this.onNineDotMouseLeave
        },
        React.createElement(
          Grid,
          { columns: 3 },
          React.createElement(
            Grid.Row,
            null,
            products.map(function (product) {
              var className = 'nine-dot__item';
              if (!product.hasAccess) {
                className += ' nine-dot__item--disabled';
              }
              return React.createElement(
                Grid.Column,
                { key: product.id },
                React.createElement(
                  'a',
                  {
                    className: className,
                    href: product.url,
                    rel: 'noopener noreferrer',
                    target: '_blank'
                  },
                  React.createElement(
                    'div',
                    { className: 'nine-dot-menu__icon' },
                    React.createElement(LoadSVG, {
                      colour: '#00a3c7',
                      src: product.iconLogoLocation,
                      alt: product.name
                    })
                  ),
                  product.name
                )
              );
            }),
            switchFromToken &&
            // TODO: Fix this
            /* eslint-disable eqeqeq */
            // $FlowFixMe
            switchFromToken != 0 && switchFromEmail &&
            // eslint-disable-next-line eqeqeq
            // $FlowFixMe
            switchFromEmail != 0 &&
            /* eslint-enable eqeqeq */
            React.createElement(
              Grid.Column,
              null,
              React.createElement(
                'button',
                {
                  className: 'switch-to back',
                  onClick: function onClick() {
                    return _this2.switchToClick(switchFromEmail, switchFromEmail, switchFromToken);
                  }
                },
                'Switch Back'
              )
            )
          )
        )
      )
    );
  };

  return NineDotMenu;
}(React.Component);

export default NineDotMenu;